import type { JSX } from "react";
import styled from "styled-components";
import AiIcon from "../../shared/components/icons/AiIcon";
import { loadJSData } from "../../shared/jsData";
import t from "../../shared/translations";
import { ButtonLink } from "../task/stylings";

interface IProps {
    pathId: string;
}

const StyledAiIcon = styled(AiIcon)`
    display: inline-block;
    vertical-align: middle;
    width: 45px;
    height: 45px;
    margin-left: -22px;
    margin-right: 12px;
    margin-top: -13px;
    margin-bottom: -13px;
`;

const SummaryButtonLink = styled(ButtonLink)`
    padding: 16px 32px 16px 32px;
    margin: 0;
`;

function PathSummaryButton({ pathId }: IProps): JSX.Element {
    if (!loadJSData().features.ai) {
        return null;
    }
    return (
        <SummaryButtonLink to={`${pathId}/summary`}>
            <StyledAiIcon white />
            {t("player.my-history.button-learning-path-summary")}
        </SummaryButtonLink>
    );
}

export default PathSummaryButton;
